export const propertyId = {
  PRIMARY_FLOATING_CTA: 5,
  WHATSAPP_PROP_ID: 25,
  WHATSAPP_FORM_CTA_PROP_ID: 27,
  NEWS_DETAIL_PROP_ID: 37,
  DEALER_MICROSITE_PROP_ID: 7,
  NCF_CTA_PROP_ID: 40,
  MODEL_LIST_ITEM_CTA_PROP_ID: 42,
  GET_OFFER_FROM_DEALER: 5,
  AUTHORIZE_DEALER: 6,
  OFFER_SLUG: 3,
  PIC_OVERVIEW_PROP_ID: 12,
  COMPARE_CARS_FINANCE_CTA: 35,
  FINANCE_CTA_EMI_CAl: 55,
  FINANCE_SLUG_THANK_YOU: 56,
  FINANCE_SLUG_VERSION_LIST: 57,
  NEW_CAR_OFFER_DETAIL_CTA: 59,
  TEST_DRIVE_SLUG_OFFER_CTA: 8,
  OPEN_LEAD_FORM: 26,
  FLOATING_HEADER_CTA: 9,
  MODEL_PAGE_LINKAGE_CARD_CTA: 60,
  CAROUSEL_CARD_CTA: 61,
};
